export const createWhatsAppLink = (message: string) => {
  return `https://wa.me/6289657735647?text=${encodeURIComponent(message)}`;
};